module.exports = __webpack_public_path__ + "media/images/icon-inquiry-mail-lg-99ecfaddb3f689c996ca506dabaa9405.svg";